import React, { useEffect, useState, Fragment } from 'react';
import { instanceOf } from 'prop-types';
import { connect } from 'react-redux';

import { getSurveyLink } from '../../../actions/turnkeyOmnibusActions';

import Details from './Details';
import IEStepHeader from '../IEStepHeader';

const SurveyDetails = ({ survey }) => {
  const initialState = {
    surveyLink: '',
  };
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (survey.surveyId) {
      getSurveyLink(survey.surveyId).then(res => {
        if (res) {
          setState({
            ...state,
            surveyLink: res,
          });
        } else {
          setState({
            ...state,
            surveyLink: '',
          });
        }
      });
    }
  }, []);
  return (
    <Fragment>
      <IEStepHeader />
      <div className="ie--details">
        <Details surveyDetails={survey} surveyLink={state.surveyLink} />
      </div>
    </Fragment>
  );
};

SurveyDetails.propTypes = {
  survey: instanceOf(Object),
};

const mapStateToProps = ({ turnkeyOmnibus }) => ({
  survey: turnkeyOmnibus.surveyDetails.data,
});

export default connect(
  mapStateToProps,
  { getSurveyLink }
)(SurveyDetails);
